import { memo } from "react"
import { MapboxMarkerIcon } from "./MapboxMarker"
import { useAppSelector } from "integrations/redux/hooks"
import { selectVisibleIcons } from "features/entity-caching/icons/selectors"
import { Icon } from "@nova/protobuf"
import { selectAncestorEntitiesByEntityId } from "panels/content/side-panel/slice"
import { selectLockedLayersMap } from "panels/content/side-panel/slice.new"
import { selectCurrentGeometryToolType } from "plugins/shared/geometry/SharedGeometrySlice"
import { ContextMenuPosition } from "features/map/types"

export const IconMapNodes = memo(function IconMapNodes({
    contextMenuPosition,
    setContextMenuPosition,
}: {
    contextMenuPosition: ContextMenuPosition | undefined
    setContextMenuPosition: React.Dispatch<React.SetStateAction<ContextMenuPosition | undefined>>
}) {
    const iconData = useAppSelector(selectVisibleIcons)
    return (
        <>
            {iconData.map((icon) => {
                return (
                    <IconMapNode
                        key={icon.id}
                        icon={icon}
                        contextMenuPosition={contextMenuPosition}
                        setContextMenuPosition={setContextMenuPosition}
                    />
                )
            })}
        </>
    )
})

function IconMapNode({
    icon,
    contextMenuPosition,
    setContextMenuPosition,
}: {
    icon: Icon
    contextMenuPosition: ContextMenuPosition | undefined
    setContextMenuPosition: React.Dispatch<React.SetStateAction<ContextMenuPosition | undefined>>
}) {
    const someGeometryToolIsInUse = !!useAppSelector(selectCurrentGeometryToolType)
    const ancestors = useAppSelector(selectAncestorEntitiesByEntityId(icon.id))
    const lockedLayersById = useAppSelector(selectLockedLayersMap)

    return (
        <MapboxMarkerIcon
            key={icon.id}
            icon={icon}
            contextMenuOpen={!!contextMenuPosition}
            setContextMenuPosition={setContextMenuPosition}
            isDisabled={
                someGeometryToolIsInUse ||
                lockedLayersById[icon.id] ||
                !!ancestors.find((ancestor) => ancestor.locked)
            }
        />
    )
}
